module.exports = __webpack_public_path__ + "media/images/group-9a1b811f73828247258936d80e4eb5b1.svg";